require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-mayor-hogsett-recognizes-financial-center-first-cu-for-its-financial.json") })
        }
      }, "path---articles-mayor-hogsett-recognizes-financial-center-first-cu-for-its-financial");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-mayor-hogsett-recognizes-financial-center-first-cu-for-its-financial!./.cache/json/articles-mayor-hogsett-recognizes-financial-center-first-cu-for-its-financial.json
// module id = 1710
// module chunks = 231608221292675